export default function ItemContentDirective() {
  return {
    template: require('./item-content.html'),
    scope: {
      item: '=',
      canEdit: '=',
      canDelete: '=',
      agendaIsActive: '=',
      canChangeStatus: '='
    },
    controller: 'ItemContentController',
    controllerAs: 'itemContentVM',
    bindToController: true,
    replace: true
  };
}
